import { gql } from '@apollo/client'

export const GET_ALL_TIME_LINES_BY_CATEGORY_AND_DOCUMENT_ID = gql`
  query GetAllTimelinesByCategoryAndDocumentId(
    $category: TimelineCategory!
    $document_id: Int!
  ) {
    getAllTimelinesByCategoryAndDocumentId(
      category: $category
      document_id: $document_id
    ) {
      id
      status_id
      user_id
      date_status
      text
      UserOfTimeline {
        id
        name
        id_role
        charge
        JobPositionOfUser {
          name
        }
      }
      StatusOfTimeline {
        name
        description
        progress
        color
        order
      }
    }
  }
`

export const GET_ALL_REPORT_TIME_LINE_BY_REPORT_ID = gql`
  query GetAllReportTimelinesByReportId($reportId: Int!) {
    getAllReportTimelinesByReportId(reportId: $reportId) {
      id
      status_id
      user_id
      date_status
      UserOfReportTimeline {
        id
        name
        id_role
        charge
        JobPositionOfUser {
          name
        }
      }
      StatusOfReportTimeline {
        name
        description
        progress
        color
        order
      }
    }
  }
`

export const GET_LAST_ONES_TIMELINES = gql`
  query GetLastOnesTimelines($category: [TimelineCategory], $limit: Int) {
    getLastOnesTimelines(category: $category, limit: $limit) {
      id
      document_id
      status_id
      user_id
      date_status
      StatusOfTimeline {
        name
      }
      TimelineToReports {
        folio
      }
      TimelineToWaterTruckRequest {
        folio
      }
    }
  }
`
